/**
 * Authors: mariushirjanu
 * Created: 20/07/2021
 */
import { Component, Input } from '@angular/core';

@Component({
  selector: 'list-contacts',
  template: `
    <div class="contact-info" *ngFor="let roleContact of roleContacts">
      <contact-info [roleContact]="roleContact"></contact-info>
    </div>
    <div class="contact-info" *ngFor="let contact of contacts">
      <contact-info [contact]="contact"></contact-info>
    </div>
  `
})
export class ListContactsComponent {
  @Input() public roleContacts:string;
  @Input() public contacts:string;
}